import React from "react"
import FormattedMessage from "@irati/utils/lang"
import {H2} from "@irati/ui/src//Typography/Heading"
import {Label2} from "@irati/ui/src/Labels"
import {getQuery} from "../../helpers/getOnboardingQuery"
import RequestNewLink from "../../components/UserOnboarding/RequestNewLinkButton"

interface Props {}

const MalformedLink: React.FC<Props> = () => {
  const {uuid} = getQuery()

  return (
    <div>
      <H2 small>
        <FormattedMessage id="onboarding.malformed.header" />
      </H2>
      <Label2 block small>
        <FormattedMessage id="onboarding.malformed.body" /> {uuid && <RequestNewLink body="onboarding.malformed.requestNewBody" />}
      </Label2>
      <Label2 block>
        <FormattedMessage id="onboarding.malformed.body2" />
      </Label2>
    </div>
  )
}

export default MalformedLink
